<script module>
  export const i18n = {
    en: {},
    sv: {
      'Review tickets': 'Granska biljetter',
      'Select class and seat preference for your tickets.':
        'Välj klass och sittplatser för dina biljetter.'
    },
    da: {
      'Review tickets': 'Gennemgå billetter',
      'Select class and seat preference for your tickets.':
        'Vælg klasse og siddepladser til dine billetter.'
    }
  }
</script>

<script>
  import OfferSelection from '$lib/OfferSelection.svelte'
  import { register } from '$lib/utils/text.svelte.js'
  import { getBooking } from '../booking.js'
  import Html from '$lib/Html.svelte'

  let text = register(i18n)

  const booking = getBooking()

  let segmentCollections =
    /** @type {(Schema.SegmentCollection & { segments: Schema.Segment[], offers: Schema.Offer[]})[]} */ (
      $derived(
        booking.selections
          ?.filter((item) => item.__typename === 'JourneyOfferSelection')
          .flatMap(
            (/** @type {Schema.JourneyOfferSelection} */ item) =>
              item.journey.itinerary
          )
          .filter(
            (item) =>
              item.__typename === 'SegmentCollection' &&
              item.segments &&
              item.offers
          )
      )
    )

  /** @type {Schema.Offer[]} */
  let selectedOffers = $derived(
    booking.selections
      ?.filter((item) => item.__typename === 'JourneyOfferSelection')
      .flatMap(
        (/** @type {Schema.JourneyOfferSelection} */ item) => item.offers
      ) || []
  )
</script>

<div class="page">
  <Html size="large">
    <h1 class="h2">{text`Review tickets`}</h1>
    <p class="lead">
      {text`Select class and seat preference for your tickets.`}
    </p>
  </Html>

  <ol class="items">
    {#each segmentCollections as { segments, offers }}
      {@const selectedOffer = selectedOffers?.find((selectedOffer) =>
        offers?.some((offer) => selectedOffer.id === offer.id)
      )}
      <li class="theme-reset">
        <OfferSelection
          passengers={booking.passengers || []}
          {selectedOffer}
          {segments}
          {offers} />
      </li>
    {/each}
  </ol>
</div>

<style>
  .page {
    display: grid;
    gap: 2rem;
  }

  .lead {
    line-height: 1.3;
    text-wrap: balance;
    margin-top: 0.4rem;
  }

  .items {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
  }
</style>
